/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const QuoteType = {
    FixedPrice: 'FIXED_PRICE',
    TimeAndMaterials: 'TIME_AND_MATERIALS'
} as const;
export type QuoteType = typeof QuoteType[keyof typeof QuoteType];


export function instanceOfQuoteType(value: any): boolean {
    for (const key in QuoteType) {
        if (Object.prototype.hasOwnProperty.call(QuoteType, key)) {
            // @ts-ignore
            if (QuoteType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function QuoteTypeFromJSON(json: any): QuoteType {
    return QuoteTypeFromJSONTyped(json, false);
}

export function QuoteTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteType {
    return json as QuoteType;
}

export function QuoteTypeToJSON(value?: QuoteType | null): any {
    return value as any;
}

